module.exports = __webpack_public_path__ + "img/zone.2806a8d3.png";